<template>
    <div>{{value}}</div>
</template>

<script>
export default {
    name : "IdDisplay",
    props : {
        value : {
            required : false,
        },
    },
}
</script>

<style scoped>

</style>
